import * as yup from 'yup';

import { ModeValues } from './EntitiesTagEditor';

export const validationSchema = yup.object().shape({
  tags: yup
    .array()
    .of(yup.string())
    .when('mode', {
      is: (mode) => mode !== ModeValues.REPLACE,
      then: yup.array().min(1, 'At least one Tag is required.'),
    }),
});
